module.exports = __webpack_public_path__ + "img/17878_S.21dca23c.png";